import React, { FC, memo, useContext, useMemo } from "react";
import { useEffectOnce } from "@swiggy-private/core-ui";
// types
import { PreStateData, States } from "@super-ui/components/m2c-swiggy-black-halfcard/types";
// components
import PreStateCtas from "./Components/PreStateCtas";
import VariantV1 from "./Components/VariantV1";
import VariantV2 from "./Components/VariantV2";

// styles
import { BullsEyeHalfCard, BullsEyeWrapper } from "./styles";
// contexts
import { M2CHalfcardContext } from "@super-ui/contexts";
// constants
import { M2C_HALFCARD_FREQUENCY_CAPPING_KEY } from "@super-ui/components/m2c-halfcard/constants";
import { isEmpty } from "@swiggy-private/js-utils";

interface PreStateLayoutProps extends PreStateData {
    addingSuperToCart: boolean;
    setAddingSuperToCart: (value: boolean) => void;
    setStateToRender: (state: States) => void;
    preStateHeightRef: React.RefObject<HTMLDivElement>;
    isOneLite?: boolean;
}

const PreStateLayout: FC<PreStateLayoutProps> = props => {
    const { bottomSheetData, addingSuperToCart, setAddingSuperToCart, preStateHeightRef } = props;
    const { ctas, title, contentImage } = bottomSheetData;
    const {
        analyticsEvents: { onImpressionM2CHalfcard },
        frequencyCappingKey = M2C_HALFCARD_FREQUENCY_CAPPING_KEY,
    } = useContext(M2CHalfcardContext);

    useEffectOnce(() => onImpressionM2CHalfcard(title, frequencyCappingKey));

    const isVariantV1 = useMemo(() => isEmpty(contentImage), [contentImage]);
    return (
        <BullsEyeHalfCard ref={preStateHeightRef}>
            <BullsEyeWrapper isVariantV1={isVariantV1}>
                {/* Variant V1 corresponds to the variant where the layout is created at the frontend by reading backend fields. 
                    Variant V2 conrrespons to variant where layout is sent as an image from backend and we directly renders it. */}
                {isVariantV1 ? <VariantV1 {...bottomSheetData} /> : <VariantV2 {...bottomSheetData} />}
                <PreStateCtas
                    {...props}
                    ctas={ctas}
                    addingSuperToCart={addingSuperToCart}
                    setAddingSuperToCart={setAddingSuperToCart}
                />
            </BullsEyeWrapper>
        </BullsEyeHalfCard>
    );
};

export default memo(PreStateLayout);
